import { cn } from "./cn.js";

type Props = {
	/** Larger mark for the empty-home hero; smaller for the auth boot. */
	size?: "boot" | "home";
	/**
	 * `loop` — loading boot. `once` — soft sweep on home, then rest.
	 * `off` — static wordmark.
	 */
	shimmer?: "loop" | "once" | "off";
	className?: string;
};

/**
 * Theme-aware Mairko wordmark with an optional light sweep.
 * Shared by auth boot and the empty-home hero so brand moments stay one thing.
 */
export function MairkoMark({
	size = "home",
	shimmer = "once",
	className,
}: Props) {
	return (
		<div
			className={cn(
				"mairko-mark",
				size === "boot" && "mairko-mark--boot",
				size === "home" && "mairko-mark--home",
				className,
			)}
			role="img"
			aria-label="Mairko"
		>
			<img
				className="mairko-mark-logo brand-logo--dark"
				src="/brand/mairko-logo-primary.svg"
				alt=""
				width={200}
				height={44}
				draggable={false}
			/>
			<img
				className="mairko-mark-logo brand-logo--light"
				src="/brand/mairko-logo-onlight.svg"
				alt=""
				width={200}
				height={44}
				draggable={false}
			/>
			{shimmer !== "off" ? (
				<span
					className={cn(
						"mairko-mark-shimmer",
						shimmer === "loop" && "mairko-mark-shimmer--loop",
						shimmer === "once" && "mairko-mark-shimmer--once",
					)}
					aria-hidden
				/>
			) : null}
		</div>
	);
}
